import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FloatingButtonComponent } from './floating-button.component';
import { MatIconModule } from '@angular/material/icon';
import { MatRippleModule } from '@angular/material/core';
import { TranslateModule } from '@ngx-translate/core';
@NgModule({
  declarations: [FloatingButtonComponent],
  imports: [CommonModule, MatIconModule, MatRippleModule, TranslateModule],
  exports: [FloatingButtonComponent],
})
export class FloatingButtonModule {}
